import {sortByKey} from 'presentation/utils';
import {makePostProvidersDentalGuide} from 'main/factories/usecases/private/guide-flow/remote-dental-guide/post-providers-factory';
import {PostProvidersDentalGuideParams} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';
import {NetworkTypesEnum, TypeLocalNameEnum} from 'domain/usecases';
import {parseOdontoSupportNetworkUnits} from 'presentation/modules/booking/odonto/utils/parseOdontoSupportNetworkUnits';

export async function postProvidersDentalGuide(params: PostProvidersDentalGuideParams) {
	const units = await makePostProvidersDentalGuide().post(params);

	if (!units) {
		return {
			units: [],
			name: NetworkTypesEnum.SUPPORT,
		};
	}

	const supportNetworkResponseParsedUnits = parseOdontoSupportNetworkUnits(units);

	const sortedUnitsByName =
		supportNetworkResponseParsedUnits && sortByKey(supportNetworkResponseParsedUnits, 'name');
	const sortedUnitsByDistance =
		supportNetworkResponseParsedUnits &&
		sortByKey(supportNetworkResponseParsedUnits, 'distance');

	const shouldSortByDistance =
		params.tpLocalidade?.toUpperCase() === TypeLocalNameEnum.COORDENADAS;

	const unitsFormatted = {
		units: shouldSortByDistance ? sortedUnitsByDistance : sortedUnitsByName,
		name: NetworkTypesEnum.SUPPORT,
	};

	return unitsFormatted;
}
